const ushift = (a, b) => a >>> b;
export default ushift;
